import React, { FC } from "react";
import { useNavigate } from "react-router";

import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Typography from "@mui/material/Typography";

import { routes } from "routes/routes";

import { ReactComponent as IbanLogo } from "assets/images/iban_oplata-logo.svg";

interface HeaderProps {
  website?: boolean;
}

type AllProps = HeaderProps;

const TransparentHeader: FC<AllProps> = () => {
  const navigate = useNavigate();

  const onLogoClick = () => {
    navigate(routes.root);
  };

  return (
    <AppBar color="transparent" position="relative">
      <Box display="flex" flexDirection="row" alignItems="center">
        <IbanLogo
          data-testid="app-logo"
          onClick={onLogoClick}
          style={{ cursor: "pointer" }}
        />
        <Typography data-testid="app-name" variant="body1" sx={{ ml: 1.5 }}>
          IBAN oplata
        </Typography>
      </Box>
    </AppBar>
  );
};

export default TransparentHeader;
